module.exports = __webpack_public_path__ + "images/fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/fb.jpg
// module id = 872
// module chunks = 3